import { render } from "./LoadingButton.vue?vue&type=template&id=1ec2eeba"
import script from "./LoadingButton.vue?vue&type=script&lang=ts"
export * from "./LoadingButton.vue?vue&type=script&lang=ts"
script.render = render

export default script